export default __webpack_public_path__ + "static/media/facebook.4572f314.svg";